import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { MediaService } from '../../services/mediaservice/media.service';
import { Router, RouterModule } from '@angular/router';
import { environment } from 'src/environments/environment';
import { DashboardService } from '../../services/dashboardservices/dashboard.service';
import { SharedModeService } from '../../services/shared-mode.service';
import { Observable } from 'rxjs';
import { NewsUpdatesComponent } from '../news-updates/news-updates.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare let $: any;

@Component({
  selector: 'app-news-updates-list',
  templateUrl: './news-updates-list.component.html',
  styleUrls: ['./news-updates-list.component.css'],
  standalone: true,
  imports: [NewsUpdatesComponent, CommonModule, FormsModule, RouterModule]
})
export class NewsUpdatesListComponent implements OnInit {

  gallery: any[] = [];
  showSpinner = false;
  selectedMedia: any;
  showFullImage = false;
  page = 1;
  user: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  userInfo: any;
  image_id: any;
  isNewsUpdateShow: any;
  mediaObject: any[] = [];
  imageArray: any[] = [];

  constructor(
    private mediaService: MediaService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    this.user_detail();

  }

  getImagePath(): string {
    return `${environment.imageBaseURL}`;
  }

  ngOnInit(): void {
    this.showSpinner = true;
    this.mediaService.showMedia().subscribe(response => {
      if (response.success) {
        response.data.forEach((x: any) => {
          this.image_id = x.id;
          if (x.path !== 'null') {
            this.gallery.push(x);
          }
        });
        this.showSpinner = false;
      } else {
        this.showSpinner = false;
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/Info_icon.svg" alt="image">',
          title: 'Data not exist.',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
    $(document).ready(function () {

      $("#imageModal").modal('show');
    });
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

  }

  toggleMode(mode: string) {
    this.sharedmode.setMode(mode);
  }

  gotoGallery() {
    this.router.navigate(['/news-update-gallery']);
  }

  openModal(media: any) {
    this.mediaObject[0] = media
    this.isNewsUpdateShow = true
    $("#imageModal").modal('show');
  }


  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data;
      this.colormode = this.userInfo.color_mode;
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    });
  }




}
